import React from 'react';
import * as action from '../Actions';
import Service from '../../service/Service';
const service = new Service();

export default function CatMenuDesktop({ eleRef, mainCategoryCont }) {
    console.log("eleRef in CatMenuDesktop: ", eleRef);
    let categoryList = eleRef.state.categoryList;
    let allCategories = categoryList.allCategories ? categoryList.allCategories[0] : [];
    console.log("categoryList in CatMenuDesktop: ", categoryList);

    return (
        <div className="categories-menu left">
            <ul>
                <li className="all-categories">
                    <div className="M16_42" role="text" tabIndex={0} aria-label="All Categories">ALL CATEGORIES</div>
                </li>
                {allCategories && allCategories.map((list, index) =>
                    <li key={index} className={((eleRef.props.location.pathname.split("?")[0].split('/')[2].split("-").join(" ").toLowerCase().includes('and') ? eleRef.props.location.pathname.split("?")[0].split('/')[2].split("-").join(" ").toLowerCase().replace(/and/g,'&') : eleRef.props.location.pathname.split("?")[0].split('/')[2].split("-").join(" ").toLowerCase())  == list.categoryName.toLowerCase().trim() ) ? "category active-cat" : "category"} onClick={() => action.gotoCatDetail(service.replaceSymbols(list.categoryName),list.isSubCatData)}>
                        <div className="M15_42" role="button" tabIndex={0} aria-label={`Go to Category : ${list.categoryName}`}  onKeyDown={(e) => {
                                                                if (e.key === 'Enter' || e.key === ' ') {
                                                                    e.preventDefault(); // prevent scrolling on Space
                                                                    action.gotoCatDetail(service.replaceSymbols(list.categoryName),list.isSubCatData);
                                                                }
                                                            }}>{list.categoryName}</div>
                    </li>
                )}
                <li className="M12_link"><span className="menu-see-more" onClick={(e) => action.LoadMaincategorylist(e,eleRef,mainCategoryCont)} role="button" tabIndex={0} aria-label="See More" onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault(); // prevent scrolling on Space
                        action.LoadMaincategorylist(e,eleRef,mainCategoryCont);
                    }
                }}>See More</span></li>
            </ul>
        </div>
    )
}
